import { render, staticRenderFns } from "./CompanyMultiRestaurantStats.vue?vue&type=template&id=56b3d8fd"
import script from "./CompanyMultiRestaurantStats.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports